import PropTypes from 'prop-types';
import React from 'react';

import appConfig from '@nerdwallet/app-config';
import Disqus from '@nerdwallet/react-disqus';
import { gql } from '@nerdwallet/apollo';
import { CommentsFragment } from '~/generated-gql/generated-types';

interface Props {
  article: CommentsFragment;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
const Comments = ({ article }: Props) => {
  const commentThreadId = article?.commentThreadId;
  const enableComments = article?.enableComments && article?.isPublished;

  if (!commentThreadId || !enableComments) {
    return null;
  }

  return <Disqus commentId={commentThreadId} env={appConfig.DISQUS_ACCOUNT} />;
};

Comments.fragment = gql`
  fragment Comments on Article {
    enableComments
    commentThreadId
    isPublished
  }
`;

Comments.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  article: PropTypes.object.isRequired,
};

export default Comments;
